function formatDate(inputTimestamp) {
  const dateObject = new Date(inputTimestamp);
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return dateObject.toLocaleDateString("en-US", options);
}

function formatTime(hours, minutes) {  
  const ampm = hours >= 12 ? 'PM' : 'AM';  
  const formattedHours = hours % 12 || 12; // converting '0' hour to '12'  
  const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;  
  return `${formattedHours}:${formattedMinutes} ${ampm}`;  
}  

function generateTimeIntervals() {  
  const intervals = [];  
  let currentTime = new Date();  
  currentTime.setHours(0, 0, 0, 0); // Start at 12:00 AM  

  for (let i = 0; i < 48; i++) { // 48 intervals for 24 hours with 30 min  
    const hours = currentTime.getHours();  
    const minutes = currentTime.getMinutes();  
    const formattedTime = formatTime(hours, minutes);  
    intervals.push(formattedTime);  
    currentTime.setMinutes(currentTime.getMinutes() + 30); // Add 30 minutes  
  }  

  return intervals;  
}  

export {
  formatDate,
  generateTimeIntervals
}